import { Mixin } from './mixin.js'
import { DateMixin } from './dateMixin.js'
import TaskState from '../Enums/TaskState.js'
import TicketState from '../Enums/TicketState.js'
import TaskCode from '../Enums/TaskCode.js'

export const mapMarkerMixin = {
    mixins: [Mixin, DateMixin],
    enums: [TaskState, TicketState, TaskCode],
    methods: { 
        getMarkerTypeFromInstallation(ins, activeInsLabel) {
            let appointmentType = this.getCurrentAppointmentType(ins)
            if (ins?.label == activeInsLabel) {
                return `${appointmentType}-active`
            }
            let status = 'pending' //STATUSES: pending, unbooked, draft, booked, active, overdue
            if (ins?.tasks?.length) {
                for (let task of ins.tasks) {
                    if (TaskCode.taskHasCode(task, TaskCode.TICKET) && TicketState.openStatesArray.includes(task.state?.value)) {
                        status = 'unbooked'
                        break;
                    } else if (TaskCode.taskHasCode(task, TaskCode.TICKET) && task.state?.value == TicketState.ON_HOLD) {
                        status = 'onhold'
                        break;
                    } else if (!TaskCode.taskHasCode(task, TaskCode.TICKET) && TaskState.openStatesArray.includes(task.state?.value)) {
                        status = 'unbooked'
                        break;
                    } else if (!TaskCode.taskHasCode(task, TaskCode.TICKET) && task.state?.value == TaskState.ON_HOLD) {
                        status = 'onhold'
                        break;
                    }
                }
            } else {
                console.error('installation has no tasks', ins)
            }
            if (ins?.appointments) {
                let appointmentKeys = Object.keys(ins.appointments)
                if (appointmentKeys.length) {
                    status = 'booked'
                    for (let key of appointmentKeys) {
                        let thisappointment = ins.appointments[key]
                        if (!thisappointment.Confirmed) {
                            status = 'draft'
                        }
                        if (thisappointment.timeWindowString < this.formatMachineDate(new Date(), '/')) {
                            status = 'overdue'
                        }
                    }
                    
                }
            }
            return `${appointmentType}-${status}`
        }
    },
}